export type TagsInput = string | string[] | null | undefined;

export const parseTags = (input: TagsInput): string[] => {
  if (Array.isArray(input)) {
    return input.map(tag => tag.trim()).filter(tag => tag.length > 0);
  }

  if (typeof input === 'string') {
    return input
      .split(',')
      .map(tag => tag.trim())
      .filter(tag => tag.length > 0);
  }

  return [];
};

export const formatTags = (input: TagsInput): string => {
  return parseTags(input).join(', ');
};
